import React, { useEffect, useState } from "react"
import i18n from "i18n"

import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import Typography from "@mui/material/Typography"
import MeasuresDataGrid from "./MeasuresDataGrid"
import PropTypes from "prop-types"

const DialogCertificateMeasures = ({
  open,
  onClose,
  partidaInfo,
  onMeasuresUpdate,
  measureCertCheckboxChecked,
  onMeasureCertCheckboxChange,
  measureCertCheckboxDisabled,
}) => {
  const [measures, setMeasures] = useState(partidaInfo?.measures || [])

  useEffect(() => {
    setMeasures(partidaInfo?.measures || [])
  }, [partidaInfo?.measures])

  const handleMeasuresUpdate = updatedMeasures => {
    setMeasures(updatedMeasures)
    if (onMeasuresUpdate) {
      onMeasuresUpdate(updatedMeasures)
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            textTransform: "uppercase",
            fontSize: "1.25rem",
          }}
        >
          {i18n.t("certMeasurements.title")}
        </Typography>
        <IconButton onClick={onClose} sx={{ ml: 1 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography
          sx={{
            fontWeight: "bold",
            mb: 1,
          }}
        >
          {i18n.t("certMeasurements.description")}:
        </Typography>
        <Typography
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            display: "block",
            mb: 3,
          }}
        >
          {partidaInfo?.name}
        </Typography>

        <MeasuresDataGrid
          measures={measures}
          onMeasuresUpdate={handleMeasuresUpdate}
          measureCertCheckboxChecked={measureCertCheckboxChecked}
          onMeasureCertCheckboxChange={onMeasureCertCheckboxChange}
          measureCertCheckboxDisabled={measureCertCheckboxDisabled}
        />
      </DialogContent>
    </Dialog>
  )
}

DialogCertificateMeasures.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  partidaInfo: PropTypes.shape({
    name: PropTypes.string,
    measures: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string,
        depth: PropTypes.number,
        height: PropTypes.number,
        width: PropTypes.number,
        quantity: PropTypes.number,
        cert_current: PropTypes.number,
      }),
    ),
  }),
  onMeasuresUpdate: PropTypes.func,
  measureCertCheckboxChecked: PropTypes.bool,
  onMeasureCertCheckboxChange: PropTypes.func,
  measureCertCheckboxDisabled: PropTypes.bool,
}

export default DialogCertificateMeasures
